module.exports = require('./provinces.json');
